import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'Overland Park, KS',
      review: 'KC24 saved us during a heat wave! Our AC broke down on the hottest day of summer, and they had a technician at our house within 2 hours. Professional, efficient, and reasonably priced. Highly recommend!',
      image: 'https://public.readdy.ai/ai/img_res/331048ecb0531e7751095994c138897f.jpg',
    },
    {
      name: 'Michael Chen',
      location: 'Kansas City, MO',
      review: 'We have been using KC24 for our annual maintenance plan for 3 years now. Their preventive care has kept our system running perfectly, and we have noticed a significant decrease in our energy bills. Great service!',
      image: 'https://readdy.ai/api/search-image?query=professional-portrait-of-satisfied-asian-man-homeowner-confident-smile-bright-natural-lighting-clean-modern-home-interior-background-genuine-happy-expression-high-quality-headshot-photography&width=400&height=500&seq=testimonial-2&orientation=portrait',
    },
    {
      name: 'Jennifer Martinez',
      location: 'Lenexa, KS',
      review: 'From the initial quote to the final installation, everything was seamless. The team installed our new furnace quickly and explained everything clearly. Our home has never been more comfortable. Five stars!',
      image: 'https://readdy.ai/api/search-image?query=professional-portrait-of-satisfied-hispanic-woman-homeowner-warm-smile-bright-natural-lighting-clean-modern-home-interior-background-genuine-happy-expression-high-quality-headshot-photography&width=400&height=500&seq=testimonial-3&orientation=portrait',
    },
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-amber-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-black rounded-3xl overflow-hidden relative">
          <div className="grid md:grid-cols-5 items-center">
            <div className="md:col-span-2 relative">
              <div className="w-full h-96 md:h-[500px]">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>

            <div className="md:col-span-3 p-8 md:p-12">
              <div className="text-amber-200 text-6xl mb-6">"</div>
              <p className="text-white text-xl md:text-2xl leading-relaxed mb-8 font-light">
                {testimonials[currentIndex].review}
              </p>
              <div className="mb-8">
                <p className="text-white font-semibold text-lg">{testimonials[currentIndex].name}</p>
                <p className="text-gray-400 text-sm">{testimonials[currentIndex].location}</p>
              </div>

              <div className="flex items-center gap-4">
                <button
                  onClick={prevTestimonial}
                  className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center text-white hover:bg-white/10 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <div className="flex gap-2">
                  {testimonials.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentIndex(index)}
                      className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                        index === currentIndex ? 'bg-white w-8' : 'bg-white/30'
                      }`}
                    ></button>
                  ))}
                </div>
                <button
                  onClick={nextTestimonial}
                  className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center text-white hover:bg-white/10 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
